
import Vue from 'vue'
import _ from 'lodash'
import * as PIXI from 'pixi.js'

class AssetsLoader {

	loaded = []

	constructor() {

		this.baseUrl = '/'
		// this.baseUrl = process.env.NODE_ENV === "production" ? '/story/joey-bada$$-political-mc/' : '/'

	}

	loadAll(array, callback, progress) {

		this.progress = progress || null
		this.amount = 0
		this.length = array.length

		let promises = []

		_.forIn(array, (asset) => {
			if (asset.type === "image") promises.push(this.load(asset))
			// else if (assets.type === "pixi") promo
		});

		Promise.all(promises).then(() => {
			callback()
		})


	}


	load(asset) {

		return new Promise(resolve => {

			let img = new Image()

			img.addEventListener('load', (e) => {

				const path = e.path ? e.path[0] : e.target

				this.loaded[asset.name] = {
					img: img,
					src: asset.src,
					width: path.width,
					height: path.height
				}

				this.amount++
				this.progress && this.progress({
					amount: this.amount,
					length: this.length
				})

				resolve()
			}, false)

			img.src = this.baseUrl + asset.url

		})

	}

	getLoadedAsset(name) {
		return this.loaded[name]
	}

}



export default new AssetsLoader()


// WEBPACK FOOTER //
// ./src/utils/assetsLoader.js